import { centerable as i } from "../decorators/centerable.js";
import { stylable as b } from "../decorators/stylable.js";
import { BLOCK_CLASSES as e } from "../../constants.js";
import l from "../../bundled_deps/.pnpm/tinycolor2@1.6.0/bundled_deps/tinycolor2/esm/tinycolor.js";
import { defineAttrs as f } from "../../utils/typed-attrs.js";
import { getBackgroundColor as g } from "./spec-util.js";
const u = (t) => {
  const r = t.querySelector("a");
  let o = r?.style?.backgroundColor;
  return o === "transparent" && (o = r?.style?.borderColor), o ? g(o) : "";
}, d = (t) => l(t).isValid() ? l(t).getLuminance() > 0.179 ? "color: #000000;" : "color: #ffffff;" : "", y = (t) => t.attrs.buttonStyle === "outline" ? `border-color: ${t.attrs?.backgroundColor}; background-color: transparent; border-style: solid;` : `border-color: transparent; background-color: ${t.attrs?.backgroundColor}; border-style: solid;`;
function c(t) {
  return t.querySelector("a")?.style?.backgroundColor === "transparent" ? "outline" : "solid";
}
const k = f({
  type: { default: "button" },
  linkUrl: { default: "" },
  text: { default: "" },
  buttonStyle: { default: "solid" }
}), x = b(
  i({
    inline: !1,
    attrs: k,
    group: "block",
    parseDOM: [
      {
        tag: `div.${e.button}`,
        getAttrs(t) {
          return {
            linkUrl: t.getAttribute("data-link-url"),
            text: t.textContent,
            backgroundColor: u(t),
            buttonStyle: c(t)
          };
        }
      },
      {
        tag: "div.intercom-interblocks-button",
        getAttrs(t) {
          return {
            linkUrl: t.querySelector("a")?.getAttribute("href"),
            text: t.textContent,
            backgroundColor: u(t),
            buttonStyle: c(t)
          };
        }
      }
    ],
    toDOM(t) {
      const r = t.attrs;
      let { text: o } = r;
      const { fontColor: n } = r;
      o ??= "Enter button text";
      const a = n ? `color: ${n};` : d(r.backgroundColor), s = y(t);
      return [
        "div",
        {
          class: `${e.blockContainer} ${e.button}`,
          "data-link-url": r.linkUrl
        },
        [
          "a",
          {
            class: "intercom-h2b-button",
            style: `${s} ${a} `
          },
          o
        ]
      ];
    }
  })
);
export {
  x as buttonSpec,
  u as getButtonBackgroundColor
};
